"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LOGIN_CHALLENGE = exports.LOGIN_BLOCK = exports.LOGIN_ALLOW = exports.DIRECT_METHOD = exports.CRYPTO_METHOD = exports.P2P_METHOD = exports.TRUSTED = exports.NOT_TRUSTED = exports.TRANSACTION_ID_FIELD = exports.SESSION_ID_FIELD = exports.ORDER_FIELD = exports.AUTO_FIELD = exports.ESCALATE = exports.REVIEW = exports.DECLINE = exports.APPROVE = void 0;
exports.APPROVE = 'A';
exports.DECLINE = 'D';
exports.REVIEW = 'R';
exports.ESCALATE = 'E';
exports.AUTO_FIELD = 'AUTO';
exports.ORDER_FIELD = 'ORDR';
exports.SESSION_ID_FIELD = 'SESS';
exports.TRANSACTION_ID_FIELD = 'TRAN';
exports.NOT_TRUSTED = 'not_trusted';
exports.TRUSTED = 'trusted';
exports.P2P_METHOD = 'P2P';
exports.CRYPTO_METHOD = 'CRYPTO';
exports.DIRECT_METHOD = 'CRYPTO_DIRECT';
exports.LOGIN_ALLOW = 'Allow';
exports.LOGIN_BLOCK = 'Block';
exports.LOGIN_CHALLENGE = 'Challenge';
